var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScopeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 7.49998C8.65827 7.49998 7.99994 8.15831 7.99994 9.99998C7.99994 11.8416 8.65819 12.5 10.4999 12.5C12.3415 12.5 12.9999 11.8416 12.9999 9.99998C12.9999 8.15831 12.3416 7.49998 10.4999 7.49998ZM17.9499 9.16665C17.5665 5.69165 14.8082 2.93331 11.3332 2.54998V0.833313H9.66652V2.54998C6.19152 2.93331 3.43319 5.69165 3.04986 9.16665H1.33319V10.8333H3.04986C3.43319 14.3083 6.19152 17.0666 9.66652 17.45V19.1666H11.3332V17.45C14.8082 17.0666 17.5665 14.3083 17.9499 10.8333H19.6665V9.16665H17.9499ZM10.4999 15.8333C7.27486 15.8333 4.66652 13.225 4.66652 9.99998C4.66652 6.77498 7.27486 4.16665 10.4999 4.16665C13.7249 4.16665 16.3332 6.77498 16.3332 9.99998C16.3332 13.225 13.7249 15.8333 10.4999 15.8333Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScopeIcon);
export default __webpack_public_path__ + "static/media/scope_icon.77940e442c84a5408fefe47477193fb2.svg";
export { ForwardRef as ReactComponent };